<script lang="ts">
  import { Input } from '@/lib/components/ui/input';
  import { Separator } from '@/lib/components/ui/separator';
  import Button from '@/lib/components/ui/button/button.svelte';
  import { cn } from '@/lib/utils';
  import ActivitySearchFilter from '@/Activities/Dashboard/ActivitySearchFilter.svelte';
  import { progressionDatePresets, type ProgressionFilterFields } from './ProgressionFilterFields';

  export let fields: ProgressionFilterFields;
</script>

{#if fields}
  <div class="flex flex-col gap-2">
    <div>
      <h3 class="text-sm font-medium tracking-wide text-muted-foreground m-0">Date Range</h3>
      <div class="flex flex-row flex-wrap gap-1 items-center mb-2">
        {#each progressionDatePresets as preset}
          <Button
            variant={fields.datePreset === preset.value ? 'default' : 'outline'}
            size="sm"
            class="rounded-full text-xs h-7 px-2"
            on:click={() => fields.setDatePreset(preset.value)}
          >
            {preset.label}
          </Button>
        {/each}
      </div>
      <div class="grid grid-cols-2 gap-2">
        <Input
          type="date"
          title="From"
          class={cn(fields.datePreset === 'custom' ? 'border-2 border-blue-400' : '', fields.dateError ? 'border-red-500' : '')}
          bind:value={fields.dateFrom}
          on:change={fields.onCustomDateChange}
        />
        <!-- A range that runs to today says "Today" rather than a date, and keeps meaning today when the page is opened again. -->
        <div class="group relative min-w-0">
          <Input
            type="date"
            title="To"
            class={cn(
              fields.datePreset === 'custom' ? 'border-2 border-blue-400' : '',
              fields.dateError ? 'border-red-500' : '',
              fields.showsEndAsToday() ? 'text-transparent focus:text-inherit' : ''
            )}
            bind:value={fields.dateTo}
            on:change={fields.onCustomDateChange}
          />
          {#if fields.showsEndAsToday()}
            <span class="absolute inset-y-0 left-3 flex items-center text-sm pointer-events-none group-focus-within:hidden">Today</span>
          {/if}
        </div>
      </div>
      {#if fields.dateError}
        <div class="text-xs text-red-600 mt-1">The start date must be on or before the end date.</div>
      {/if}
    </div>

    <Separator />

    <!-- These narrow the activity totals and averages only. The date range also sets the charts. -->
    <ActivitySearchFilter bind:fields hide={['sort', 'search', 'dates', 'location']} />
  </div>
{/if}
